import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

declare var require: any;
var Highcharts = require('highcharts/highmaps.js');
import Exporting from 'highcharts/modules/exporting';
import funnel from 'highcharts/modules/funnel';
import { ActivatedRoute, Router } from '@angular/router';
Exporting(Highcharts);
funnel(Highcharts);

@Component({
	selector: 'app-stage-process',
	templateUrl: './stage-process.component.html',
	styleUrls: ['./stage-process.component.scss']
})
export class StageProcessComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	@Input() type: any;
	@Input() selected_opportunity_period: any;
	@Output() stateChanged = new EventEmitter<any>();

	selected_step_data: any;

	stages_data: any = [];

	user_details: any;

	stage_id: any;

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
		private router: Router,
		private route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

    if (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14) {
      this.selected_tab = "MAGI"
    } else {
      this.selected_tab = this.user_details.role.role_name + " Managed";
    }

		// this.selected_tab = this.user_details.role.role_name + " Managed";

		this.route.queryParams.subscribe((params) => {
			this.stage_id = params.stage_id;

			if (this.stage_id == 0 || this.stage_id > 4) {
				this.router.navigate([], {
					queryParams: { stage_id: 1 },
				});
			}

		});

		if (this.type == "Upside Opportunities") {
			this.description_sections = this.upside_opp_description_sections;
		} else if (this.type == "Retention Opportunities") {
			this.description_sections = this.retention_opp_description_sections;
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			this.description_sections = this.leads_opp_description_sections;
			this.getBusinessPlan();
		} else if (this.type == "New Prospects") {
			this.description_sections = this.prospects_opp_description_sections;
			this.getBusinessPlan();
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			this.description_sections = this.deposit_opp_description_sections;
			this.getBusinessPlan();
		} else if (this.type == "Non Customers") {
			this.description_sections = this.non_members_opp_description_sections;
			this.getBusinessPlan();
		} else if (this.type == "Bank Customers to Lending Clients") {
			this.description_sections = this.lending_officer_opp_description_sections;
			this.getBusinessPlan();
		} else if (this.type == "Bank Customers to Insurance Clients") {
			this.description_sections = this.insurance_agent_opp_description_sections;
			this.getBusinessPlan();
		}
		this.getInnerStepData();
		// this.getStepperCountData("first");
	}

	business_plan_list: any = [];
	business_plan: any = 0;
	business_plan_loaded: boolean = true;
	getBusinessPlan() {
		this.business_plan_loaded = false;
		const financial_institution = this.user_details.financial_institution;
		this.commonService.getData('/businessPlan?no_page=true&financial_institution=' + financial_institution).subscribe(
			(res: any) => {
				this.business_plan_list = res;
				this.business_plan_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	businessPlanChange() {
		this.business_plan_loaded = false;
		setTimeout(() => {
			this.getStepperCountData("");
			this.business_plan_loaded = true;
		}, 200);
	}

	stepperChange(data) {
		// this.selected_step_data.position = "";
		setTimeout(() => {
			this.selected_step_data = data;
			// if (this.stage_id) {
			// 	this.router.navigate([], {
			// 		queryParams: { stage_id: this.selected_step_data.order },
			// 	});
			// }
			this.router.navigate([], {
					queryParams: { stage_id: this.selected_step_data.order },
				});
			this.getStepperCountData("");
		}, 200);
		// this.getStepperCountData("");
		// this.selected_step_data = data;
	}

	stepper_count_data: any;
	stepper_count_data_loaded: any;
	stepper_details_loaded: boolean = false;
	total_count: any =  0;
	getStepperCountData(instance) {
		this.stepper_count_data_loaded = false;

		let type: any = "";
		if (this.type == "Upside Opportunities") {
			type = "opportunity";
		} else if (this.type == "Retention Opportunities") {
			type = "retention";
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			type = "new";
		} else if (this.type == "New Prospects") {
			type = "new_prospect";
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			type = "members";
		} else if (this.type == "Non Customers") {
			type = "non_members";
		} else if (this.type == "Bank Customers to Lending Clients") {
			type = "lending";
		} else if (this.type == "Bank Customers to Insurance Clients") {
			type = "insurance";
		}

    // if (this.selected_tab == "MAGI") {
    //   type = "magi_" + type;
    // }

		let route: any = '/clientsalesstepcountupdated/?advisor_id=' + this.user_details.id + '&type='+ type;


		// if (this.type == "Institutional Customers to Investment Clients") {
		if (this.type == "Bank Customers to Investment Clients") {
			route = route + "&business_plan_id=" + this.business_plan;
		}

		// if (this.type == "Institutional Customers to Deposit Clients") {
		if (this.type == "Bank Customers to Deposit Clients") {
			route = route + "&business_plan_id=" + this.business_plan;
		}

		if (this.type == "New Prospects") {
			route = route + "&business_plan_id=" + this.business_plan;
		}

		if (this.type == "Non Customers") {
			route = route + "&business_plan_id=" + this.business_plan;
		}

    if (this.type == "Bank Customers to Lending Clients") {
			route = route + "&business_plan_id=" + this.business_plan;
		}

    if (this.type == "Bank Customers to Insurance Clients") {
			route = route + "&business_plan_id=" + this.business_plan;
		}


    if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
      route = "/getmagistages/" + '?type='+ type;
    }

		route = route + "&opp_year=" + this.selected_opportunity_period;

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.stages_data = res["clientsales_step_count"];
				for (let index = 0; index < this.stages_data.length; index++) {
					this.stages_data[index].step = index + 1;
				}

				// if (instance == "first") {
				// 	this.selected_step_data = this.stages_data[0];
				// 	this.stepper_details_loaded = true;
				// }

				// if (instance == "first") {
				// 	if (this.type == "Bank Customers to Investment Clients") {
				// 		this.selected_step_data = this.stages_data[1];
				// 		this.stepper_details_loaded = true;
				// 	}  else {
				// 		this.selected_step_data = this.stages_data[0];
				// 		this.stepper_details_loaded = true;
				// 	}
				// }

				if (!this.stage_id) {
					if (instance == "first") {
						// if (this.type == "Bank Customers to Investment Clients") {
						// 	this.selected_step_data = this.stages_data[1];
						// 	this.stepper_details_loaded = true;
						// }  else {
						// 	this.selected_step_data = this.stages_data[0];
						// 	this.stepper_details_loaded = true;
						// }
						this.selected_step_data = this.stages_data[0];
						this.stepper_details_loaded = true;
					}
          // else {
          //   this.selected_step_data = this.stages_data[0];
					// 	this.stepper_details_loaded = true;
          // }
				} else {
					this.selected_step_data = this.stages_data[this.stage_id - 1];
					this.stepper_details_loaded = true;
				}


				// let count: any = 0;
				// for (let index = 0; index < this.stages_data.length; index++) {
				// 	// if ((this.type == "Institutional Customers to Deposit Clients") || (this.type == "Non Customers")) {
				// 	if ((this.type == "Bank Customers to Deposit Clients") || (this.type == "Non Customers") || (this.type == "Bank Customers to Investment Clients") || (this.type == "Non Prospects")) {
				// 		if (index > 1) {
				// 			count = count + this.stages_data[index].count;
				// 		}
				// 	} else {
				// 		if (index > 0) {
				// 			count = count + this.stages_data[index].count;
				// 		}
				// 	}
				// }

				// this.total_count = count;

				this.stepper_count_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	selected_tab: any = "";
	tabChange(value) {
		this.selected_tab = value;
		this.getInnerStepData();
	}

	tab_details_count: any = {
		advisor_managed_count: 0,
		agi_count: 0,
		total_count: 0,
	};
	tab_details_loaded: boolean = false;
	getInnerStepData() {
		this.tab_details_loaded = false;

		let type: any = "";
		if (this.type == "Upside Opportunities") {
			type = "opportunity";
		} else if (this.type == "Retention Opportunities") {
			type = "retention";
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			type = "new";
		} else if (this.type == "New Prospects") {
			type = "new_prospect";
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			type = "members";
		} else if (this.type == "Non Customers") {
			type = "non_members";
		} else if (this.type == "Bank Customers to Lending Clients") {
			type = "lending";
		} else if (this.type == "Bank Customers to Insurance Clients") {
			type = "insurance";
		}

		// if (this.selected_tab == "MAGI") {
		//   type = "magi_" + type;
		// }

		let route: any = '/tabcount/?advisor_id=' + this.user_details.id + '&type='+ type;

		route = route + "&opp_year=" + this.selected_opportunity_period;

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.tab_details_count = res["tab_count"];
				this.total_count = this.tab_details_count["total_count"];
				this.tab_details_loaded = true;
				this.getStepperCountData("first");
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	navigateStep(data) {
		this.selected_step_data = data;
	}

  	back() {
		const data = {
			clickable: true,
			name: 'Summary',
		};
		this.stateChanged.emit(data);
	}

	description_sections: any = [];

	upside_opp_description_sections: any = [
		{
			name: "The definition for the section detailing the total upside opportunities within an advisor's existing book of business can be broken down into several parts for clarity:",
			sub_sections: [
				{
					name: "Overview",
					value: "This section is crafted to enlighten advisors on the breadth of untapped opportunities residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
				},
				{
					name: "Trigger Event Business Rules",
					value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
				},
				{
					name: "AI-Driven Opportunities",
					value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
				},
				{
					name: "Navigation",
					value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
				},
				{
					name: "Ranking System",
					value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
				},
				{
					name: "Purpose",
					value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
				},
			]
		},
	];

	retention_opp_description_sections: any = [
		{
			name: "The client retention risk section has been designed with a multi-faceted approach to ensure that advisors have a clear and actionable understanding of potential risks within their client base:",
			sub_sections: [
				{
					name: "Section Purpose",
					value: "The purpose of this section is to equip advisors with in-depth knowledge of the risks associated with client retention in their existing portfolios. It's a critical tool aimed at preempting client turnover and fostering long-term loyalty."
				},
				{
					name: "Trigger Event Business Rules Component",
					value: "At the core of this section are the trigger event business rules. These are insights developed by seasoned industry experts that signal potential client departure scenarios. They serve as an early warning system, indicating the possible reasons a client may be contemplating ending their financial services relationship."
				},
				{
					name: "AI-Driven Risk Detection",
					value: "Beyond conventional wisdom, the section is enhanced with AI-driven insights. This sophisticated analysis surfaces risks that would be undetectable without the advanced capabilities of AI, thus offering a deeper understanding of client sentiment and potential disengagement."
				},
				{
					name: "Detailed Risk Analysis",
					value: "Advisors can access a comprehensive breakdown of these risks by interacting with the section. A simple click reveals a detailed categorization of the risks by origin and potential impact. This feature provides a clear view of which clients are at risk and the urgency of addressing their concerns, potentially opening avenues to not only retain but also to expand business with them."
				},
				{
					name: "Prioritization of Risks",
					value: "The risks are prioritized and ranked according to severity and the timeframe within which they may affect the business. This system allows advisors to anticipate and act on retention challenges well in advance, with a 2 to 3-year lead time for strategic action and relationship reinforcement."
				},
				{
					name: "Strategic Benefits",
					value: "This section is more than just a list of risks; it's a strategic asset. It offers the advisors a chance to take preemptive actions based on a comprehensive, data-driven understanding of their client base. By focusing on the highest-ranked risks, advisors can not only secure their business against potential loss but also identify opportunities for additional engagement and revenue through tailored cross-selling strategies."
				},
			]
		},
	];


	leads_opp_description_sections: any = [
		{
			// name: "The Institutional Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			name: "The Bank Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				// {
				// 	name: "Purpose of the 'Institutional Customers to Investment Clients Section",
				// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				// },
				{
					name: "Purpose of the Bank Customers to Investment Clients Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					// value: "The 'Institutional Customers to Investment Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
					value: "The 'Bank Customers to Investment Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

	prospects_opp_description_sections: any = [
		{
			name: "The New Prospects section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				{
					name: "Purpose of the 'New Prospects' Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					value: "The 'New Prospects' section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

	deposit_opp_description_sections: any = [
		{
			// name: "The Institutional Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			name: "The Bank Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				// {
				// 	name: "Purpose of the 'Institutional Customers to Deposit Clients Section",
				// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				// },
				{
					name: "Purpose of the Bank Customers to Deposit Clients Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					// value: "The 'Institutional Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
					value: "The 'Bank Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

	non_members_opp_description_sections: any = [
		{
			name: "The Non Customers section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				{
					name: "Purpose of the Non Customers Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Non Customers into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					value: "The 'Non Customers section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

  lending_officer_opp_description_sections: any = [
		{
			// name: "The Institutional Customers to Lending Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			name: "The Bank Customers to Lending Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				// {
				// 	name: "Purpose of the 'Institutional Customers to Lending Clients Section",
				// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Lending Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				// },
				{
					name: "Purpose of the Bank Customers to Lending Clients Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Lending Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					// value: "The 'Institutional Customers to Lending Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
					value: "The 'Bank Customers to Lending Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

  insurance_agent_opp_description_sections: any = [
		{
			// name: "The Institutional Customers to Insurance Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			name: "The Bank Customers to Insurance Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				// {
				// 	name: "Purpose of the 'Institutional Customers to Insurance Clients Section",
				// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Insurance Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				// },
				{
					name: "Purpose of the Bank Customers to Insurance Clients Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Insurance Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					// value: "The 'Institutional Customers to Insurance Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
					value: "The 'Bank Customers to Insurance Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

	@ViewChild('salesFunnelModal') salesFunnelModal: TemplateRef<any>;
	private salesFunnelModalRef: MatDialogRef<TemplateRef<any>>;

	sales_funnel_data_loaded: boolean = false;
	openSalesFunnelModal() {
		this.sales_funnel_data_loaded = false;

		this.salesFunnelModalRef = this.dialog.open(this.salesFunnelModal, { disableClose: true });
		this.salesFunnelModalRef.afterClosed().subscribe((result) => {
			this.closeSalesFunnelModal();
		});

		let data: any = [];
		let count: any = 0;
		for (let index = 0; index < this.stages_data.length; index++) {
			// if ((this.type == "Institutional Customers to Deposit Clients") || (this.type == "Non Customers")) {
			if ((this.type == "Bank Customers to Deposit Clients") || (this.type == "Non Customers")) {
				if (index > 1) {
					data.push([this.stages_data[index].name, this.stages_data[index].count]);
					count = count + this.stages_data[index].count;
				}
			} else {
				if (index > 0) {
					data.push([this.stages_data[index].name, this.stages_data[index].count]);
					count = count + this.stages_data[index].count;
				}
			}
		}

		data.splice(0, 0, ["Opportunities", count]);

		this.sales_funnel_data_loaded = true;

		setTimeout(() => {
			this.createSalesFunnel(data);
		}, 200);
	}

	closeSalesFunnelModal() {
		this.salesFunnelModalRef.close();
		this.sales_funnel_data_loaded = false;
	}

	@ViewChild('salesFunnelContainer', { read: ElementRef }) salesFunnelContainer: ElementRef;
	createSalesFunnel(data) {
		Highcharts.chart(this.salesFunnelContainer.nativeElement, {
		  chart: {
			type: 'funnel',
		  },
		  // colors: ["#4ED9A7", "#FE8E6B", "#FFB800", "#757575"],
		  colors: ['#DC661D', '#c69983', '#D49E18', '#7fC310', '#028E94'],
		  exporting: {
			enabled: false,
		  },
		  title: {
			text: '',
		  },
		  plotOptions: {
			series: {
			  cursor: 'pointer',
			  // events: {
			  //     click: function (event) {
			  //       $this.selected_funnel_type = event.point.name;
			  //       $this.selected_funnel_broker = "All";
			  //       $this.getTableGraphsData();
			  //     }
			  // },
			  dataLabels: {
				enabled: true,
				format: '<b>{point.name}</b> ({point.y:,.0f})',
				softConnector: true,
			  },
			  center: ['40%', '50%'],
			  neckWidth: '20%',
			  neckHeight: '0%',
			  width: '80%',
			},
		  },
		  legend: {
			enabled: false,
		  },
		  series: [
			{
			  name: '',
			  data: data
			//   data: [
			// 	['Opportunities', 200],
			// 	['Pre-Approach', 120],
			// 	['Pitch', 20],
			// 	['Follow Up', 40],
			// 	['Results', 33],
			//   ],
			},
		  ],
		  responsive: {
			rules: [
			  {
				condition: {
				  maxWidth: 500,
				},
				chartOptions: {
				  plotOptions: {
					series: {
					  dataLabels: {
						inside: true,
					  },
					  center: ['50%', '50%'],
					  width: '100%',
					},
				  },
				},
			  },
			],
		  },
		});
	  }

	@ViewChild('agentFlowModal') agentFlowModal: TemplateRef<any>;
	private agentFlowModalRef: MatDialogRef<TemplateRef<any>>;
	openAgenticFlow() {
		this.agentFlowModalRef = this.dialog.open(this.agentFlowModal, { disableClose: true });
		this.agentFlowModalRef.afterClosed().subscribe((result) => {
			this.closeAgentFlowModal();
		});
	}

	closeAgentFlowModal() {
		this.agentFlowModalRef.close();
	}

  getFormattedNumber(value) {
    return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
  }

}
